{
  "title": "Sales Channels",
  "createSalesChannelButton": "Create Sales Channel",
  "updatesaleschannelbutton": "Update",
  "deletesaleschannelbutton": "Delete",
  "salesChannelTableHeader": {
    "salesChannelName": "Sales channel name",
    "salesChannelId": "Sales channel ID",
    "languages": "Languages"
  },
  "count": "{{count}} channels",
  "select": "Select",
  "selectAll": "Select All",
  "selected": {
    "selected_one": "{{count}} channel selected",
    "selected_other": "{{count}} channels selected",
    "exportPriceList": "Export price list",
    "editSalesChannel": "Edit",
    "delete": "Delete",
    "cancel": "Cancel"
  },
  "deleteSalesChannelConfirmationDialog": {
    "title": "Remove sales channel",
    "content_one": "Are you sure you want to remove {{count}} sales channel? This sales channel will be completely deleted.",
    "content_other": "Are you sure you want to remove {{count}} sales channels? These sales channels will be completely deleted.",
    "buttons": {
      "cancel": "Cancel",
      "delete": "Delete"
    }
  },
  "filter": {
    "textsearchtitle": "Search",
    "textsearchplaceholder": "Search..."
  },
  "pagination": {
    "show": "Show"
  },
  "errors": {
    "deleteSalesChannel": "Error occurred while removing sales channel"
  },
  "notification": {
    "errorFetch": "Error occurred while fetching products"
  }
}
